import { Platform } from "../models/api/common";

export function getPlatformLogoPath(platform: Platform) {
    switch (platform) {
        case Platform.powerplatform:
            return "assets/images/logo/ms-logo.svg";
        case Platform.powerBI:
            return "assets/images/logo/power-bi-logo.svg";
        case Platform.workato:
            return "assets/images/logo/workato-logo.svg";
        case Platform.salesforce:
            return "assets/images/logo/salesforce-logo.png";
        case Platform.serviceNow:
            return "assets/images/logo/serviceNow-logo.svg";
        case Platform.chatGptEnterprise:
            return "assets/images/logo/chatGptEnterprise.svg";
        default:
            throw new Error(`getPlatformLogoPath: platform ${platform} not supported`);
    }
}

export function getPlatformDisplayName(platform: Platform) {
    switch (platform) {
        case Platform.powerplatform:
            return "Power Platform";
        case Platform.powerBI:
            return "Fabric";
        case Platform.serviceNow:
            return "ServiceNow";
        case Platform.workato:
            return "Workato";
        case Platform.salesforce:
            return "Salesforce";
        case Platform.chatGptEnterprise:
            return "ChatGPT Enterprise";
        default:
            throw new Error(`getPlatformDisplayName: platform ${platform} not supported`);
    }
}
